export {Table, Table as default} from './table';
export type {TableProps} from './table';
export {Caption} from './caption';
export type {CaptionProps} from './caption';
export {Body} from './body';
export type {BodyProps} from './body';
export {Head} from './head';
export type {HeadProps} from './head';
export {Foot} from './foot';
export type {FootProps} from './foot';
export {Row} from './row';
export type {RowProps} from './row';
/** @deprecated Create custom layouts on the consumer side instead. It will be removed in 6 months 03-03-2026. */
export {Headline} from './headline';
export type {HeadlineProps} from './headline';
/** @deprecated Create custom layouts on the consumer side instead. It will be removed in 6 months 03-03-2026. */
export {Subtitle} from './subtitle';
export type {SubtitleProps} from './subtitle';
export {SyncHeight} from './sync-height';
export type {SyncHeightProps, SyncHeightRenderProps} from './sync-height';
export {Cell} from './cell';
export type {CellProps} from './cell';
/** @deprecated Use the `textAlign` prop with plain strings instead. It will be removed in 6 months 03-03-2026. */
export {TextAlign} from './constants';
/** @deprecated Use `TextAlignType` instead. It will be removed in 6 months 03-03-2026. */
export type {TextAlignLegacyType} from './constants';
/** @deprecated Use the `align` prop with plain strings instead. It will be removed in 6 months 03-03-2026. */
export {VerticalAlign} from './constants';
/** @deprecated Use `AlignType` instead. It will be removed in 6 months 03-03-2026. */
export type {VerticalAlignType} from './constants';
